import tenantRouterOptions from "#build/tenant-router.options";
import routerOptions0 from "/app/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
  ...tenantRouterOptions,
...routerOptions0,
...routerOptions1,
}